import type { ConfigObjectMatch, ContentUpdateResult } from '@cli-types/next-adapter/init.js'
import { upsertTopLevelBooleanProperty } from './upsert-top-level-boolean-property.js'

export function ensureCacheComponents(
  content: string,
  configObject: ConfigObjectMatch
): ContentUpdateResult {
  return upsertTopLevelBooleanProperty(content, configObject, 'cacheComponents')
}
